import {h, Fragment} from "preact"
// export default ({}) => {
//     return (
//         <div
//             class="ns-loader-wrapper ns-d-flex ns-justify-content-center ns-align-items-center"
//             style="position: absolute; z-index: 1;"
//         >
//             <div class="ns-loader"></div>
//         </div>
//     )
// }

export default ({}) => {
    const cards = Array.from({ length: 8 });

    return (
        <div class="ns-skeleton-wrapper">
            <div class="ns-skeleton-filters">
                <div class="ns-skeleton-pill"></div>
                <div class="ns-skeleton-pill" style="width:96px;"></div>
                <div class="ns-skeleton-pill" style="width:64px;"></div>
                <div class="ns-skeleton-pill" style="width:110px;"></div>
            </div>

            <div class="ns-skeleton-grid">
                {cards.map((_, i) => (
                    <div class="ns-skeleton-card-wrap" key={i}>
                        <div class="ns-skeleton-card">
                            <div class="ns-skeleton-image"></div>
                            <div class="ns-skeleton-content">
                                <div class="ns-skeleton-line" style="width:75%;height:13px;"></div>
                                <div class="ns-skeleton-line" style="width:45%;height:11px;"></div>
                                <div class="ns-skeleton-line" style="width:30%;height:13px;margin-top:auto;"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};